module.exports = __webpack_public_path__ + "static/media/about-img.25a0ea39.png";